import { useEffect, useState } from "react";

import {
  CallHistoryEntry,
  clearHistory,
  loadHistory,
  subscribeHistory,
  togglePin,
} from "../../../helpers/grpc-call-history";

interface UseCallHistoryResult {
  history: CallHistoryEntry[];
  clear: () => void;
  togglePin: (id: string) => void;
}

/**
 * Live view of the gRPC call history. Seeds from localStorage and stays in
 * sync via the store's subscription (the logging interceptor records calls and
 * notifies subscribers), so any consumer re-renders as calls come in without
 * repeating the useState/useEffect wiring.
 */
export const useCallHistory = (): UseCallHistoryResult => {
  const [history, setHistory] = useState<CallHistoryEntry[]>(loadHistory);

  useEffect(() => subscribeHistory(setHistory), []);

  // clearHistory/togglePin notify subscribers, which updates `history` above.
  return { history, clear: clearHistory, togglePin };
};
